import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import { useFetchContextlessContractsPermissions } from './useFetchContextlessContractsPermissions'

interface UseFetchContractsPermissionsType {
  loading: boolean
}

export const useFetchContractsPermissions = (
  employee: Employee
): UseFetchContractsPermissionsType => {
  const { loading: loadingContextless } = useFetchContextlessContractsPermissions()
  const { loading } = useAsyncData(async () => {
    await Promise.all([
      policyAuthorizations.authorizePolicies('contracts.delete_contracts', [employee]),
      policyAuthorizations.authorizePolicies('contracts.promote', [employee]),
      policyAuthorizations.authorizePolicies('contracts.edit', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_additional_compensation', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_contract_extra_info', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_contract_type', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_end_date', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_gross_salary', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_job_title', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_payroll_policy', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_start_date', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_trial_period', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_trial_period_end_date', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_working_day_type', [employee]),
      policyAuthorizations.authorizePolicies('contracts.see_working_hours', [employee]),
      policyAuthorizations.authorizePolicies('job_catalog.create_job', []),
    ])
  }, [employee.id])
  return {
    loading: loading || loadingContextless,
  }
}
